import { useState } from "react";

interface AdvancedState<T> {
  state: T;
  setState: React.Dispatch<React.SetStateAction<T>>;
  updateState: (updatedState: Partial<T>) => void;
  toggleField: (fieldName: keyof T) => void;
  resetState: () => void;
}

export const useAdvancedState = <T extends Record<string, any>>(defaultValues: T): AdvancedState<T> => {
  const [state, setState] = useState<T>(defaultValues);
  const [defaultState] = useState<T>(defaultValues);

  const updateState = (updatedState: Partial<T>): void => {
    setState((prevState) => ({
      ...prevState,
      ...updatedState,
    }));
  };

  const toggleField = (fieldName: keyof T): void => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  const resetState = (): void => {
    setState(defaultState);
  };

  return { state, setState, updateState, toggleField, resetState };
};
